"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const DrippingClasses = ({ dripping }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    if (dripping.allClasses) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dripping_2.columns.classes.all') });
    }
    if (dripping.classes.length === 1) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: dripping.classes[0].name });
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dripping_2.columns.classes.some', {
            data: { value: dripping.classes.length }
        }) }));
};
exports.default = DrippingClasses;
